import axios from 'axios';
import URLS from '@/store/urls';
import notificationWithIcon from '@/utils/notification';

const actions = {
  async login({ commit }, payload) {
    try {
      const { email, password } = payload;
      const { data: { data } } = await axios.post(URLS.signin, {
        email: email.trim().toLowerCase(),
        password,
      });
      localStorage.setItem('id_token', (data.accessToken));
      localStorage.setItem('access_token', (data.accessToken));
      const { data: { data: profileData } } = await axios.get(URLS.userProfile, {
        headers: {
          Authorization: `Bearer ${data.accessToken || data.token}`,
        },
      });
      commit('loginSuccess', {
        ...data,
        email,
        permissions: data.permissions,
        pagePermissions: data.pagePermissions,
      });
      setTimeout(() => {}, 1000); // для  првоерки работы компании
      localStorage.setItem('id', (profileData.id));
      localStorage.setItem('role', (profileData.role));
      localStorage.setItem('firstName', (profileData.firstName));
      localStorage.setItem('lastName', (profileData.lastName));
      localStorage.setItem('email', (profileData.email));
      localStorage.setItem('avatarUrl', (profileData.avatarUrl));
      localStorage.setItem('company', JSON.stringify(profileData?.company || {}));
      if (profileData.permissions) {
        localStorage.setItem('permissions', JSON.stringify(profileData.permissions || []));
      }
      if (profileData.pagePermissions) {
        localStorage.setItem('pagePermissions', JSON.stringify(profileData.pagePermissions || []));
      }
      commit('userProfileSuccess', profileData);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit('loginFailure', message);
    }
  },
  checkAuthorization({ commit }) {
    const token = localStorage.getItem('id_token');
    const accessToken = localStorage.getItem('access_token');
    const permissions = localStorage.getItem('permissions') || [];
    const pagePermissions = localStorage.getItem('pagePermissions') || [];
    const role = localStorage.getItem('role');
    const id = localStorage.getItem('id');
    const email = localStorage.getItem('email');
    const firstName = localStorage.getItem('firstName');
    const lastName = localStorage.getItem('lastName');
    const avatarUrl = localStorage.getItem('avatarUrl');
    const companyStr = localStorage.getItem('company');
    let company = null;
    try {
      company = companyStr ? JSON.parse(companyStr) : null;
    } catch (e) {
      company = null;
    }
    if (token || accessToken) {
      commit('loginSuccess', {
        accessToken,
        token,
      });
      commit('userProfileSuccess', {
        id,
        role,
        email: email.trim().toLowerCase(),
        firstName,
        lastName,
        avatarUrl,
        permissions,
        pagePermissions,
        company,
      });
    }
  },
  logout({ commit }) {
    localStorage.removeItem('id_token');
    localStorage.removeItem('access_token');
    localStorage.removeItem('permissions');
    localStorage.removeItem('pagePermissions');
    localStorage.removeItem('role');
    localStorage.removeItem('id');
    localStorage.removeItem('email');
    localStorage.removeItem('firstName');
    localStorage.removeItem('lastName');
    localStorage.removeItem('avatarUrl');
    localStorage.removeItem('company');
    commit('logout');
  },
};

export default actions;
